import React from "react";
import { Controller } from "react-hook-form";
import { FieldProp } from "../model/FieldProp";
import { IntegerModel } from "../../../businessFoundation/Primitives/IntegerManage/IntegerModel";
import { TextField } from "@episerver/ui-framework";

const IntegerField: React.FC<FieldProp<any>> = (props) => {
    const { index, property, control, errors } = props;
    const validationData = property.validationData as IntegerModel;

    return (
        <Controller
            name={`extendedProperties[${index}].value`}
            control={control}
            rules={{
                required: {
                    value: !property.isNullable,
                    message: `${property.friendlyName} is required`,
                },
                min: {
                    value: validationData.minValue,
                    message: `${property.friendlyName} is invalid`,
                },
                max: {
                    value: validationData.maxValue,
                    message: `${property.friendlyName} is invalid`,
                },
                pattern: {
                    value: /^([-][1-9]){0,1}[0-9]*$/i,
                    message: `${property.friendlyName} is invalid`,
                },
            }}
            render={({ field: { onChange, value } }) => (
                <TextField
                    id={`extendedProperties[${index}].value`}
                    type="text"
                    outlined
                    label={property.friendlyName}
                    helperText={errors.extendedProperties
                        ? errors.extendedProperties[index]?.value?.message ?? property.description
                        : property.description}
                    invalid={errors.extendedProperties && errors.extendedProperties[index]?.value ? true : false}
                    value={value ?? ""}
                    onChange={onChange}
                />
            )}
        />
    );
};

export default IntegerField;
